import { getApiUrl } from '../../util/api/api'

  const deleteDefaultlogo = async () => {
    const response = await fetch(
      getApiUrl('/dashboard/api/recruiter/company/logo'), {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      }
    )
    
    if (response?.ok) {
      const responseJson = await response.json()
      return Promise.resolve({ status: response.status, data: responseJson})
    } else {
      return Promise.reject(response ? { status: response.status, data: response.statusText } : null)
    }
  }
  
  export default deleteDefaultlogo
